var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChamber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300.00005 300",
    id: "svg23100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chamber",
    style: {
      display: "inline"
    },
    transform: "matrix(2.72727 0 0 2.72727 -678.81268 -611.32768)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 1.00001,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9",
    d: "M249.39799 224.65349H358.398v108.99999H249.39799Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15021-1",
    style: {
      display: "inline",
      fill: "gray",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "m2.8305751-120.43049-5.8302999.0973-2.8302605 5.09887 3.0000394 4.99976 5.8302999-.0982 2.8293428-5.09795zm115.3321949 0-5.8303.0973-2.82934 5.09887 3.00004 4.99976 5.82938-.0982 2.83026-5.09795zM2.8305751-5.0982951l-5.8302999.098196L-5.8299853.0978571l3.0000394 4.9997598 5.8302999-.097279L5.8296968-.09761829zm115.3321949 0-5.8303.098196-2.82934 5.0979562 3.00004 4.9997598 5.82938-.097279 2.83026-5.09795619z",
    transform: "translate(258.898 324.15349) scale(.78035)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChamber);
export default __webpack_public_path__ + "static/media/chamber.00eb933f75dde76480e54322d76cf3e8.svg";
export { ForwardRef as ReactComponent };